import React from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { doc } from "firebase/firestore";
import { useFirestore, useFirestoreDocDataOnce } from "reactfire";
import Loading from "../components/LoadingComponent";
import AppInstall from "../components/AppInstall";
import { getMobileOperatingSystem } from "../utils/get_mobile_os";
import { androidAppURL, iosAppURL } from "../config/config";

const SpeakerProjectPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const podcastRef = doc(useFirestore(), "speakers", id);
  const { status, data } = useFirestoreDocDataOnce(podcastRef);

  if (status === "loading") {
    return (
      <div className="h-screen w-full flex justify-center items-center">
        <Loading />
      </div>
    );
  } else if (status === "error") {
    return <div>Something went wrong...</div>;
  }

  // destructure data
  const projectIndex = searchParams.get("projectIndex") || 0;
  const company_projects = data.company_projects || [];
  const project = company_projects[projectIndex];
  
  const projectTitle = project['title'];
  const projectImage = project['image'];


  return (
    <div
      className="container mx-auto"
    >
      {/* app install banner */}
      <div className="mb-16 mt-0 sm:mt-4">
        <AppInstall />
      </div>
      {/* app install banner */}


      <p className="px-4 mt-4 md:text-center">{projectTitle}</p>

      <img src={projectImage} alt="project" className="mx-auto mt-4 w-full md:w-96 bg-gray-100" />

      <p className="mt-4 px-4 font-bold md:text-center">
        Please install the R24 app to discover more about this project.
      </p>


      <div className="mt-4"></div>
        <a
        
          href={
            getMobileOperatingSystem() === "android" ||
            getMobileOperatingSystem() === "windows"
              ? androidAppURL
              : getMobileOperatingSystem() === "ios"
              ? iosAppURL
              : androidAppURL
          }
        >
          <img 
            src="/assets/banner-768-wide.jpg" 
            alt="download r24 app" 
            className="w-full block sm:hidden" 
          />
          <img 
            src="/assets/banner-960-wide.jpg" 
            alt="download r24 app" 
            className="w-full hidden sm:block md:hidden" 
          />
          <img 
            src="/assets/banner-1920-wide.jpg" 
            alt="download r24 app" 
            className="w-full hidden md:block" 
          />
        </a>
    
      {/* bottom cta */}
      {/* <div className="md:w-3/4 mx-auto md:rounded fixed bottom-0 left-0 right-0 bg-gray-200 p-4 ">
        <PlayerTips />
      </div> */}
      {/* bottom cta */}
    </div>
  );
};

export default SpeakerProjectPage;
